import { Schema } from "effect";
import { Conference } from "./Conferences.js";
import { DarkquellInferredSkill } from "./Darkquell.js";
import { GenericLink } from "./GenericLink.js";
import { GraphReference } from "./GraphReference.js";
import { Interview } from "./Interview.js";
import { InterviewSummary } from "./InterviewSummary.js";
import { MeetingStatus } from "./MeetingStatus.js";
import { MissionControlConfig } from "./MissionControlConfig.js";
import { ModelOutput } from "./ModelOutput.js";
import { RealtimeTranscript } from "./Transcript.js";
import { RecallBot } from "./Recall.js";
import { RecruiterSettings } from "./RecruiterSettings.js";
import { TalentMeetingDetails } from "./TalentMeetingDetails.js";
import { TalentGeoIP } from "./TalentGeoIP.js";
import { TeamsConversation } from "./TeamsConversations.js";
import { TimeslotLock } from "./TimeslotLock.js";
import { UserConfig } from "./UserConfigSchema.js";
import { CaptionsInfo } from "./TalentClientCaptions.js";
import { BotPresenceStatus, InterviewPresenceStatus } from "./Presence.js";
import { PredictionResponse } from "./SkillClassifier.js";
import { FeatureFlag } from "./FeatureFlags.js";
import { InterviewMetrics } from "./InterviewMetrics.js";
export const MissionControl = {
    conferences: {
        schema: Conference,
    },
    config: {
        schema: MissionControlConfig,
    },
    darkquellTemp: {
        name: "darkquell_temp",
        subcollections: {
            skills: {
                schema: DarkquellInferredSkill,
            },
        },
    },
    genericLinks: {
        schema: GenericLink,
    },
    graphReference: {
        schema: GraphReference,
    },
    interviews: {
        schema: Interview,
    },
    interviewMetrics: {
        schema: InterviewMetrics,
    },
    interviewSummaries: {
        schema: InterviewSummary,
    },
    meetingStatus: {
        schema: MeetingStatus,
    },
    modelOutput: {
        schema: ModelOutput,
    },
    recallBots: {
        schema: RecallBot,
    },
    recruiterSettings: {
        schema: RecruiterSettings,
    },
    rrts: {
        schema: RealtimeTranscript,
    },
    talentMeetingDetails: {
        schema: TalentMeetingDetails,
    },
    talentGeoIP: {
        schema: TalentGeoIP,
    },
    teamsConversations: {
        schema: TeamsConversation,
    },
    timeslotLocks: {
        schema: TimeslotLock,
    },
    userConfig: {
        schema: UserConfig,
    },
    transcript: {
        schema: Schema.Struct({
            iId: Schema.String,
            timeToLive: Schema.optional(Schema.Unknown),
            transcript: Schema.Array(CaptionsInfo),
        }),
        subcollections: {
            tempTranscript: {
                schema: CaptionsInfo,
            },
        },
    },
    interviewPresenceStatus: {
        schema: InterviewPresenceStatus,
    },
    botPresenceStatus: {
        schema: BotPresenceStatus,
    },
    skillclassifierTemp: {
        name: "skillclassifier_temp",
        subcollections: {
            skills: {
                schema: PredictionResponse,
            },
        },
    },
    featureFlags: {
        schema: FeatureFlag,
    },
};
